import { Component } from "@angular/core";

@Component({
	selector: 'logout-screen',
	templateUrl: './logout.component.html',
	styleUrls: ['./logout.component.css']
})
export class LogoutComponent {
}